/**
 * Root App Component with React Router v7
 *
 * Simplified entry point that delegates all routing to AppRouter
 */

import React from 'react'
import AppRouter from './components/AppRouter'

/**
 * Root App Component with React Router v7
 */
const App: React.FC = () => {
  return <AppRouter />
}

export default App